import React, {Suspense} from "react";
import {render} from "react-dom";
import CreateForgeApp from "../../../components/forge-apps";
import NavHeader from "../../../components/nav-header";
import BreadCrumbs from "../../../components/breadcrumbs";
import NavSidebar from "../../../components/nav-sidebar";
import JumpLinks from "../../../components/jump-links";
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { ProfileProvider } from '../../../hooks/useProfile.jsx';


(async () => {
    // Client-Side IDs are not secret
    // https://docs.launchdarkly.com/sdk/client-side/react/react-web#getting-started

    let clientSideId;

    switch (window.location.hostname) {
    case "forge.autodesk.com":
        clientSideId = "620d9f16f72c7914c61de4c1";
        break;
    case "aps.autodesk.com":
        clientSideId = "620d9f16f72c7914c61de4c1";
        break;
    case "stg.forge.autodesk.com":
        clientSideId = "620d9f18c9f56d1487a0c804";
        break;
    case "aps-stg.autodesk.com":
        clientSideId = "620d9f18c9f56d1487a0c804";
        break;
    default:
        clientSideId = "620d9f19d8e9ea0bb4c36ce0";
        break;
    }

  const LDProvider = await asyncWithLDProvider({
    clientSideID: clientSideId,
    reactOptions: {
      useCamelCaseFlagKeys: false,
    }
  });

  // Renders components
  if (document.getElementById("app-navbar") !== null) {
      render(
      <LDProvider>
        <ProfileProvider>
          <NavHeader/>
        </ProfileProvider>
      </LDProvider>, document.getElementById("app-navbar"));
  }
})();

// BreadCrumbs
const displayBreadCrumb = () => {
  const breadCrumbHeader = document.createElement("div");

  let page = document.querySelector(".api-documentation");
  if (page && !document.getElementById("breadCrumbs")) {
    page.prepend(breadCrumbHeader);
  }

  if (page && breadCrumbHeader) {
    breadCrumbHeader.id = "breadCrumbs";
    render(<BreadCrumbs/>, document.getElementById("breadCrumbs"));
  }
};

// Sidebar Menu
const displaySidebar = () => {
  const sidebar = document.createElement("div");

  let page = document.querySelector(".doc_holder");
  if (page && !document.getElementById("nav-sidebar")) {
    page.prepend(sidebar);
  }

  if (page && sidebar) {
      let resourceUrl = '//developer.static.autodesk.com';
      let followLink = false;
      if(document.querySelector('.page-node-type-documentation-page')) {
        followLink = true;
      }
      if (typeof server_url !== 'undefined') {
        resourceUrl = server_url;
      }
      sidebar.id = "nav-sidebar";
      render(<NavSidebar resourceUrl={resourceUrl} followLink={followLink}/>, document.getElementById("nav-sidebar"));
  }
};

// Jump links
const displayJumpLinks = () => {
  const jumpLinksSidebar = document.createElement("div");

  let page = document.querySelector(".api-documentation");
  if (page && !document.getElementById("jumpLinks")) {
    page.parentElement.prepend(jumpLinksSidebar);
  }

  if (page && jumpLinksSidebar) {
    jumpLinksSidebar.id = "jumpLinks";
    render(<JumpLinks/>, document.getElementById("jumpLinks"));
  }
};

displaySidebar();
displayJumpLinks();
displayBreadCrumb();
window.addEventListener("updatedPage", displaySidebar);
window.addEventListener("updatedPage", displayJumpLinks);
window.addEventListener("updatedPage", displayBreadCrumb);

if (document.getElementById("btn-forge-app-create")) {
  const elemWithClasses =
    ".xb-content-aside.xbca-type-button.app-button-container";
  document.getElementById("btn-forge-app-create").remove();

  render(<CreateForgeApp/>, document.querySelector(elemWithClasses));
}
